// @flow

import { PersistenceRegistry, ReducerRegistry, set } from "../../../base/redux";
import * as actionTypes from "../../actionTypes";

const STORE_NAME = "features/nxatel_meet";

// PersistenceRegistry.register(STORE_NAME, {
//     // meetings_list:[]
// });

const DEFAULT_STATE = {
    meetings_list: [],
    meetings_count: 0,
    recording_count: 0,
    recording_list: [],
    extension_list: [],
    invite_meet: false,
    invite_lobby: false,
    meeting_details:{},
    timezone_list:[],
    edit_meet:{},
    video_record_listing:[],
    documents_listing:[],
    participant_is_host:false,
    default_lobby:false
};

ReducerRegistry.register(STORE_NAME, (state = DEFAULT_STATE, action) => {  
    switch (action.type) {
        case actionTypes.MEETINGS_LIST:
            return {
                ...state,
                meetings_list: action.payload,
            };
        case actionTypes.MEETINGS_COUNT:
            return {
                ...state,
                meetings_count: action.payload,
            };
        case actionTypes.RECORDING_LIST:
            return {
                ...state,
                recording_list: action.payload,
            };
        case actionTypes.RECORDING_COUNT:
            return {
                ...state,
                recording_count: action.payload,
            };
        case actionTypes.FETCH_EXTENSION_LISTING:
            return {
                ...state,
                extension_list: action.payload,
            };
        case actionTypes.INVITE_FOR_MEET:
            return {
                ...state,
                invite_meet: action.payload,
            };
        case actionTypes.INVITE_FOR_LOBBY:
            return {
                ...state,
                invite_lobby: action.payload,
            };
        case actionTypes.MEETING_DETAILS:
            return {
                ...state,
                meeting_details: action.payload,
            };
        case actionTypes.TIMEZONE_LIST:
            return {
                ...state,
                timezone_list: action.payload,
            };
        case actionTypes.EDIT_MEET_DATA:
            return {
                ...state,
                edit_meet: action.payload,
            };
        case actionTypes.VIDEO_RECORDING_LIST:
            return {
                ...state,
                video_record_listing: action.payload,
                };    
        case actionTypes.DOCUMENTS_LIST:
            return {
                ...state,
                documents_listing: action.payload,
                };    
        case actionTypes.PARTICIPANT_IS_HOST:
            return {
                ...state,
                participant_is_host: action.payload,
            };    
        case actionTypes.DEFAULT_LOBBY_IS_ON:
            return {
                ...state,
                default_lobby: action.payload,
            };    
        default:
            return state;
    }
});
